var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateClientHotline } from '@/actions/ClientHotlineActions';
import Layout from '@/container/Layout';
import { usePrevPathContext } from '@/context/PrevPathContext';
import { useHotlineClientCreateFormContext } from '@/feature/hotline/client/create/context/HotlineClientCreateFormContext';
import { HotlineClientCreateInputView } from '@/feature/hotline/client/create/input/page/HotlineClientCreateInputView';
import { getHotlineClientCreateSubmitValues } from '@/feature/hotline/client/create/util/getHotlineClientCreateSubmitValues';
import { canUseHotlineClientUser } from '@/feature/hotline/client/util/canUseHotlineUser';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン投稿入力（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineClientCreateInputPage = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const profile = useTypeSelector((state) => state.profile);
    // 「戻るボタン」のリンク取得
    const prevPath = usePrevPathContext();
    // form の値を取得
    const { formValues, setFormValues } = useHotlineClientCreateFormContext();
    /** ホットライン利用可能なユーザーか */
    const canUseHotline = useMemo(() => canUseHotlineClientUser(profile), [profile]);
    const onSubmit = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        // バリデーションを実行
        yield wrapDispatch(dispatch, apiCreateClientHotline({
            json: getHotlineClientCreateSubmitValues(formValue),
        }, {
            isValidateOnly: true,
        }));
        if (!unmountRef.current) {
            // state に保存
            setFormValues(formValue);
            // 送信後は確認画面へ遷移
            history.push(pagePath.hotline.client.createConfirm());
        }
    }), [dispatch, history, setFormValues, unmountRef]);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.client.createInput(), title: '匿名コンサルホットライン 相談 - 入力 | PROFFIT' }), _jsx("div", Object.assign({ className: canUseHotline ? '' : 'fixed inset-0' }, { children: _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineClientCreateInputView, { canUseHotline: canUseHotline, defaultValues: formValues, onSubmit: onSubmit, prevLinkPath: prevPath || pagePath.mypage.client.hotline() }) })) }))] }));
};
